var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "talent-list" },
    [
      _vm.$route.name === "scholarSearchHistoryGuoJiao" ||
      _vm.$route.name === "scholarSearchHistory"
        ? _c(
            "h3",
            {
              style: {
                top:
                  _vm.$route.name === "scholarSearchHistoryGuoJiao"
                    ? "0"
                    : "80px",
              },
            },
            [
              _c("b", [_vm._v("来源专家")]),
              _c("el-input", {
                staticClass: "search-scholar-input",
                attrs: {
                  size: "small",
                  placeholder: "请输入专家姓名或机构",
                  clearable: "",
                },
                model: {
                  value: _vm.searchScholarInput,
                  callback: function ($$v) {
                    _vm.searchScholarInput = $$v
                  },
                  expression: "searchScholarInput",
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._l(_vm.filteredList, function (talentItem, index) {
        return _c(
          "div",
          { key: index, staticClass: "talent-item" },
          [
            _c("el-avatar", {
              staticClass: "avatar",
              attrs: { size: 45, src: talentItem.avatar },
              on: {
                click: function ($event) {
                  return _vm.toScholarDetails(talentItem.scholar_id)
                },
              },
            }),
            _c("div", { staticClass: "talent-info" }, [
              _c(
                "div",
                { staticClass: "name-title" },
                [
                  _c(
                    "span",
                    {
                      on: {
                        click: function ($event) {
                          return _vm.toScholarDetails(talentItem.scholar_id)
                        },
                      },
                    },
                    [_vm._v(_vm._s(talentItem.scholar_name))]
                  ),
                  _vm._l(talentItem.showLeftList, function (tit, idx) {
                    return _c("i", { key: idx, attrs: { title: tit } }, [
                      _vm._v(_vm._s(tit)),
                    ])
                  }),
                ],
                2
              ),
              _c("div", { staticClass: "info" }, [
                _c("label", { staticStyle: { "line-height": "18px" } }, [
                  _vm._v("所在机构："),
                ]),
                _c(
                  "span",
                  {
                    staticStyle: { cursor: "pointer" },
                    on: {
                      click: function ($event) {
                        return _vm.toOrgDetail(talentItem)
                      },
                    },
                  },
                  [_vm._v(_vm._s(talentItem.org_name || "-"))]
                ),
              ]),
              _c("div", { staticClass: "info" }, [
                _c("label", { staticStyle: { "line-height": "18px" } }, [
                  _vm._v("研究领域："),
                ]),
                talentItem.fields && talentItem.fields.length
                  ? _c(
                      "p",
                      _vm._l(talentItem.fields, function (field, i) {
                        return _c("span", { key: i }, [
                          _vm._v(_vm._s(field.name) + "；"),
                        ])
                      }),
                      0
                    )
                  : _c("p", [_vm._v("-")]),
              ]),
              _c("div", { staticClass: "data-number" }, [
                _c("div", { staticClass: "flex" }, [
                  _c("p", [
                    _vm._v(" 成果数："),
                    _c("span", [
                      _vm._v(_vm._s(talentItem.publications_count || "-")),
                    ]),
                  ]),
                  _c("p", [
                    _vm._v(" H指数："),
                    _c("span", [_vm._v(_vm._s(talentItem.hindex || "-"))]),
                  ]),
                  _c("p", [
                    _vm._v(" 引用数："),
                    _c("span", [_vm._v(_vm._s(talentItem.citedby || "-"))]),
                  ]),
                ]),
              ]),
              _c("div", { staticClass: "infoLine" }, [
                _c("span", { staticClass: "flex items-center" }, [
                  _vm._v("个人主页："),
                ]),
                _c(
                  "div",
                  {
                    staticClass: "pointer flex justify-center items-center",
                    staticStyle: {
                      width: "21px",
                      height: "21px",
                      "border-radius": "50%",
                      "background-color": "#3860F4",
                    },
                    style: {
                      backgroundColor: talentItem.person_url
                        ? "#3860F4"
                        : "#999999",
                    },
                    on: {
                      click: function ($event) {
                        return _vm.goInfoUrl(talentItem.person_url)
                      },
                    },
                  },
                  [
                    _c("img", {
                      attrs: {
                        width: "14px",
                        height: "14px",
                        src: require("@/assets/images/talent/boshi.png"),
                        alt: "",
                      },
                    }),
                  ]
                ),
                _c(
                  "div",
                  {
                    staticClass: "flex justify-center items-center pointer",
                    staticStyle: {
                      width: "21px",
                      height: "21px",
                      "border-radius": "50%",
                      "margin-left": "10px",
                    },
                    style: {
                      backgroundColor: talentItem.googleAddress
                        ? "#3860F4"
                        : "#999999",
                    },
                    on: {
                      click: function ($event) {
                        return _vm.goInfoUrl(talentItem.googleAddress)
                      },
                    },
                  },
                  [
                    _c("img", {
                      attrs: {
                        width: "14px",
                        height: "14px",
                        src: require("@/assets/images/talent/google.png"),
                        alt: "",
                      },
                    }),
                  ]
                ),
              ]),
            ]),
          ],
          1
        )
      }),
      !_vm.filteredList.length ? _c("el-empty") : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }